import type * as Types from '@precon-tools-suite-by-shared/precon-graphql-types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type RolesClaimFallbackQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type RolesClaimFallbackQuery = {
  __typename: 'Query',
  me?: {
    __typename: 'AccessToken',
    roles?: Array<Types.Role> | null,
    user?: {
      __typename: 'User',
      id: string
    } | null,
    team?: {
      __typename: 'Team',
      id: string
    } | null
  } | null
};


export const RolesClaimFallbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RolesClaimFallback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"roles"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"team"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RolesClaimFallbackQuery, RolesClaimFallbackQueryVariables>;